import type { Breakpoint } from 'antd';

export const BREAKPOINTS: Record<Breakpoint, number> = {
    lg: 992,
    md: 768,
    sm: 576,
    xl: 1200,
    xs: 0,
    xxl: 1600,
    xxxl: 1920,
};
